<template>
  <div class="flex flex-col gap-5">
    <div v-for="(item, index) in formScheme" :key="index" class="flex flex-col gap-2">
      <div class="text-sm font-medium text-gray-900">
        {{ item.label }}
      </div>
      <component
        :is="componentId(item.type)"
        v-model="formValues[item.key]"
        :options="item?.options || item?.original?.options || []"
        :data="item?.data || item?.original?.data"
        :multiple="item?.multiple || item?.original?.multiple"
        :input-type="item?.inputType || item?.original?.inputType"
        :clearable="item?.clearable || item?.original?.clearable"
        :label="item?.original?.label"
        :input-id="item?.original?.inputId || item?.inputId"
        :disabled="item?.original?.inputId || item?.disabled"
      />
    </div>
  </div>
</template>

<script>
import formComponents from "@/misc/import-file.js";

export default {
  components: { ...formComponents },
  props: {
    scheme: { type: Array, default: () => null },
    value: { type: [Object, Array] },
    api: { type: String, default: () => "" },
  },
  data() {
    return {
      formValues: {},
      formScheme: null,
    };
  },
  watch: {
    formValues: {
      deep: true,
      handler(n, old) {
        console.log(n);
        if (!Object.values(old).length) return;

        this.$emit("input", n);
        this.$emit("change", n);
      },
    },
  },
  async mounted() {
    await this.setFromData();
    this.formScheme = await this.getFormScheme();
    // console.log(this.formScheme);
  },
  methods: {
    componentId(type) {
      return `vs-form-${type.toLowerCase()}`;
    },
    setFromData() {
      const valueIsObject = this.value !== null || typeof this.value === "object" || !Array.isArray(this.value);
      const values = valueIsObject ? this.value : {};

      this.formValues = { ...this.formValues, ...values };
    },
    async getFormScheme() {
      if (!this.api && !this.scheme) throw new Error("Form error: Scheme or API url is required!");

      if (!this.api) return this.scheme;

      try {
        const resp = await fetch(this.api);

        if (resp.ok) {
          const data = await resp.json();

          return data?.components || data;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss"></style>
